import { useNavigate, useSearchParams } from 'react-router-dom';
import { getRefundableFareService } from '@/services';
import { useAppContext } from '@/context';

export const useFreight = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const freightId = searchParams.get('frete');
  const truckerId = searchParams.get('motorista');
  const { state, dispatch } = useAppContext();

  const updateURL = (uri: string, key: string, value: string) => {
    const separator = uri.includes('?') ? '&' : '?';
    return `${uri}${separator}${key}=${value}`;
  };

  const navigateWithFreight = (uri: string) => {
    let url = uri;
    if (freightId) url = updateURL(url, 'frete', freightId);
    if (truckerId) url = updateURL(url, 'motorista', truckerId);
    navigate(url);
  };

  const verifyIfHasFarePaid = async () => {
    if (!freightId || !truckerId || !state.truckerProfile.data?.profileId) return false;

    try {
      const response = await getRefundableFareService(freightId, state.truckerProfile.data.profileId);
      dispatch({ action: 'set_fare_paid', payload: response.data.farePaid });

      return response.data.farePaid;
    } catch {
      return false;
    }
  };

  return { freightId, truckerId, navigateWithFreight, verifyIfHasFarePaid };
};
